import React from 'react';
import Link from '@/_application/core/components/ui/link';
import {ImageOptimized} from '@/_application/core/components/ui/image';

interface IProps {
    imageUrl: string;
    alt: string;
    width: number;
    height: number;
    className?: string;
    bannerUrl?: string | null;
}

const BannerImage: React.FC<IProps> = ({imageUrl, alt, width, height, className, bannerUrl}) => {
    if (!imageUrl) {
        return <></>;
    }

    return (
        <>
            {bannerUrl ? (
                <Link href={bannerUrl}>
                    <ImageOptimized src={imageUrl} alt={alt} width={width} height={height} className={className} />
                </Link>
            ) : (
                <ImageOptimized src={imageUrl} alt={alt} width={width} height={height} className={className} />
            )}
        </>
    );
};

export default BannerImage;
